import { createFeature, createReducer, on } from '@ngrx/store'
import { initialState } from './payout-agreement.state'
import { payoutAgreementActions, payoutRevisionActions } from './payout-agreement.actions'

export const payoutAgreementReducer = createReducer(
  initialState,
  on(payoutAgreementActions.clearPayoutAgreement, state => ({
    ...state,
    payout: null,
    revisedPayout: null,
    allPayouts: null,
    allPayoutsByBusiness: null,
    loading: false,
    error: null
  })),
  on(payoutAgreementActions.addBusinessRequirements, (state, { belongsTo, employeeId }) => ({
    ...state,
    payout: {
      ...(state.payout || {}),
      belongsTo,
      employeeId,
      payoutFrequency: null,
      statutoryCompliances: null,
      basis: null,
      ctc: null,
      currency: null,
      effectiveFrom: null,
      payoutFrom: null,
      payoutData: null
    }
  })),
  on(payoutAgreementActions.addStatutoryCompliances, (state, { statutoryCompliances }) => ({
    ...state,
    payout: {
      ...(state.payout || {}),
      belongsTo: state.payout?.belongsTo ?? null,
      employeeId: state.payout?.employeeId ?? null,
      payoutFrequency: state.payout?.payoutFrequency ?? null,
      statutoryCompliances,
      basis: state.payout?.basis ?? null,
      ctc: state.payout?.ctc ?? null,
      currency: state.payout?.currency ?? null,
      effectiveFrom: state.payout?.effectiveFrom ?? null,
      payoutFrom: state.payout?.payoutFrom ?? null,
      payoutData: state.payout?.payoutData ?? null
    }
  })),
  on(
    payoutAgreementActions.addCTCData,
    (state, { payoutFrequency, ctc, currency, basis, effectiveFrom, payoutFrom }) => ({
      ...state,
      payout: {
        ...(state.payout || {}),
        belongsTo: state.payout?.belongsTo ?? null,
        employeeId: state.payout?.employeeId ?? null,
        payoutFrequency,
        statutoryCompliances: state.payout?.statutoryCompliances ?? null,
        basis,
        ctc,
        currency,
        effectiveFrom,
        payoutFrom,
        payoutData: state.payout?.payoutData ?? null
      }
    })
  ),
  on(payoutAgreementActions.updateCTCValue, (state, { ctcValue }) => ({
    ...state,
    payout: {
      ...(state.payout || {}),
      payoutFrequency: state.payout?.payoutFrequency ?? null,
      basis: state.payout?.basis ?? null,
      ctc: ctcValue,
      currency: state.payout?.currency ?? null,
      effectiveFrom: state.payout?.effectiveFrom ?? null,
      payoutFrom: state.payout?.payoutFrom ?? null,
      payoutData: state.payout?.payoutData ?? null,
      belongsTo: state.payout?.belongsTo ?? null,
      employeeId: state.payout?.employeeId ?? null,
      statutoryCompliances: state.payout?.statutoryCompliances ?? null
    }
  })),
  on(payoutAgreementActions.addPayoutData, (state, { payoutData }) => ({
    ...state,
    payout: {
      ...(state.payout || {}),
      belongsTo: state.payout?.belongsTo ?? null,
      employeeId: state.payout?.employeeId ?? null,
      payoutFrequency: state.payout?.payoutFrequency ?? null,
      statutoryCompliances: state.payout?.statutoryCompliances ?? null,
      basis: state.payout?.basis ?? null,
      ctc: state.payout?.ctc ?? null,
      currency: state.payout?.currency ?? null,
      effectiveFrom: state.payout?.effectiveFrom ?? null,
      payoutFrom: state.payout?.payoutFrom ?? null,
      payoutData
    }
  })),
  on(payoutAgreementActions.addPayoutAgreementFailure, state => ({
    ...state,
    payout: null,
    revisedPayout: null,
    allPayouts: null,
    allPayoutsByBusiness: null,
    loading: false,
    error: null
  })),
  on(payoutAgreementActions.loadAllPayoutAgreementsSuccess, (state, { payoutAgreements }) => ({
    ...state,
    allPayouts: payoutAgreements,
    loading: false,
    error: null
  })),
  on(payoutAgreementActions.loadPayoutAgreementSuccess, (state, { payoutAgreement }) => ({
    ...state,
    payout: payoutAgreement
  })),
  // --- Revision Workflow Reducers ---
  // Update Revised Business Requirements
  on(payoutRevisionActions.initiatePayoutRevision, (state, { belongsTo, employeeId }) => ({
    ...state,
    revisedPayout: {
      ...(state.payout || {}),
      payoutFrequency: state.payout?.payoutFrequency ?? null,
      statutoryCompliances: state.payout?.statutoryCompliances ?? null,
      basis: state.payout?.basis ?? null,
      ctc: state.payout?.ctc ?? null,
      currency: state.payout?.currency ?? null,
      effectiveFrom: state.payout?.effectiveFrom ?? null,
      payoutFrom: state.payout?.payoutFrom ?? null,
      payoutData: state.payout?.payoutData ?? null,
      belongsTo,
      employeeId
    }
  })),
  // Update Revised Statutory Compliances
  on(payoutRevisionActions.updateStatutoryCompliances, (state, { statutoryCompliances }) => ({
    ...state,
    revisedPayout: {
      ...(state.revisedPayout || {}),
      payoutFrequency: state.revisedPayout?.payoutFrequency ?? null,
      basis: state.revisedPayout?.basis ?? null,
      ctc: state.revisedPayout?.ctc ?? null,
      currency: state.revisedPayout?.currency ?? null,
      effectiveFrom: state.revisedPayout?.effectiveFrom ?? null,
      payoutFrom: state.revisedPayout?.payoutFrom ?? null,
      payoutData: state.revisedPayout?.payoutData ?? null,
      belongsTo: state.revisedPayout?.belongsTo ?? null,
      employeeId: state.revisedPayout?.employeeId ?? null,
      statutoryCompliances
    }
  })),
  //Update Revised ctc value
  on(payoutRevisionActions.updateCTCValue, (state, { ctcValue }) => ({
    ...state,
    revisedPayout: {
      ...(state.revisedPayout || {}),
      payoutFrequency: state.revisedPayout?.payoutFrequency ?? null,
      basis: state.revisedPayout?.basis ?? null,
      ctc: ctcValue,
      currency: state.revisedPayout?.currency ?? null,
      effectiveFrom: state.revisedPayout?.effectiveFrom ?? null,
      payoutFrom: state.revisedPayout?.payoutFrom ?? null,
      payoutData: state.revisedPayout?.payoutData ?? null,
      belongsTo: state.revisedPayout?.belongsTo ?? null,
      employeeId: state.revisedPayout?.employeeId ?? null,
      statutoryCompliances: state.revisedPayout?.statutoryCompliances ?? null
    }
  })),
  //Update Revised ctc
  on(payoutRevisionActions.updateCTCData, (state, { ctc }) => ({
    ...state,
    revisedPayout: {
      ...(state.revisedPayout || {}),
      payoutFrequency: ctc.payoutFrequency,
      statutoryCompliances: state.revisedPayout?.statutoryCompliances ?? null,
      basis: ctc.basis,
      currency: ctc.currency,
      ctc: ctc.ctc,
      effectiveFrom: ctc.effectiveFrom,
      payoutFrom: ctc.payoutFrom,
      payoutData: state.revisedPayout?.payoutData ?? null,
      belongsTo: state.revisedPayout?.belongsTo ?? null,
      employeeId: state.revisedPayout?.employeeId ?? null
    }
  })),
  //Update Revised Payout Data
  on(payoutRevisionActions.updatePayoutData, (state, { payoutData }) => ({
    ...state,
    revisedPayout: {
      ...(state.revisedPayout || {}),
      payoutFrequency: state.revisedPayout?.payoutFrequency ?? null,
      statutoryCompliances: state.revisedPayout?.statutoryCompliances ?? null,
      basis: state.revisedPayout?.basis ?? null,
      ctc: state.revisedPayout?.ctc ?? null,
      currency: state.revisedPayout?.currency ?? null,
      effectiveFrom: state.revisedPayout?.effectiveFrom ?? null,
      payoutFrom: state.revisedPayout?.payoutFrom ?? null,
      payoutData,
      belongsTo: state.revisedPayout?.belongsTo ?? null,
      employeeId: state.revisedPayout?.employeeId ?? null
    }
  }))
  ////Save Revised Salary
  //on(scActions.salaryRevisionActions.saveRevisedSalarySuccess, (state, { salary }) => ({
  //  ...state,
  //  employeeSalary: { ...salary },
  //  revisedSalary: createInitialSalaryDraft()
  //}))
)

export const payoutAgreementFeature = createFeature({
  name: 'payoutAgreement',
  reducer: payoutAgreementReducer
})

export const {
  name,
  reducer,
  selectPayout,
  selectAllPayouts,
  selectRevisedPayout,
  selectPayoutAgreementState
} = payoutAgreementFeature
